if ($('#contadores-home')[0]) {
  function downCounter(trigger, start, numstart, numend, target, duration) {
    var num = { var: numstart },
      endCount = numend,
      tl = gsap

    tl.timeline({
      scrollTrigger: {
        trigger: trigger,
        start: start,
        scrub: false,
        //markers: true,
      },
    }).to(num, {
      var: endCount,
      duration: duration,
      ease: 'Power0.easeNone',
      onUpdate: function () {
        $(target).text(numberWithCommas(num.var.toFixed()))
      },
    })
  }

  downCounter('#contadores-home', 'top 50%', 1, 14, '#counter-anos', 1.5)
  downCounter('#contadores-home', 'top 50%', 850, 1000, '#counter-eventos', 3)
  downCounter('#contadores-home', 'top 50%', 699850, 700000, '#counter-personas', 3)
  downCounter('#contadores-home', 'top 50%', 1, 125, '#counter-clientes', 2.5)

  function numberWithCommas(nStr) {
    nStr += ''
    var x = nStr.split('.')
    var x1 = x[0]
    var x2 = x.length > 1 ? '.' + x[1] : ''
    var rgx = /(\d+)(\d{3})/
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2')
    }
    return x1 + x2
  }
}

if ($('#nav-fixed')[0]) {
  menuAnimado()
}

function menuAnimado() {
  let tl = gsap

  tl.timeline({
    scrollTrigger: {
      trigger: 'main',
      start: 'top top',
      //markers: true,
      toggleClass: { className: 'bottom', targets: '#nav-fixed' },
    },
  })
}
